<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cambiar Precio de Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <h4 class="todo-content-header">
                  <i i class="os-icon os-icon-ui-83"></i
                  ><span v-if="current.producto"
                    >{{ current.producto.nombre }} -
                    {{ current.producto.sku }}</span
                  >
                </h4>

                <div class="col-12">
                  <h6>
                    Lista de Precio: {{ lista_precio.id }} -
                    {{ lista_precio.nombre }}
                  </h6>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.unidad_medida &&
                          current.errors.unidad_medida.length > 0,
                      }"
                      >Unidad de Medida</label
                    >
                    <select
                      class="form-control"
                      v-model="current.unidad_medida"
                      @change="unidadMedidaChange"
                    >
                      <option
                        v-for="(unidad_medida, key) in unidades_medidas"
                        :value="unidad_medida.id"
                        :key="key"
                      >
                        {{ unidad_medida.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.unidad_medida"
                      class="form-text text-danger"
                      >{{ current.errors.unidad_medida[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for>Habilitado Desde</label>
                    <div class="date-input">
                      <input
                        id="valido_desde"
                        ref="valido_desde"
                        class="single-daterange form-control"
                        placeholder="Habilitado Desde"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for>Habilitado Hasta</label>
                    <div class v-if="!fecha_final">
                      <input
                        @click="habilitarFechaFinal"
                        type="button"
                        class="btn btn-sm btn-warning"
                        value="Agregar Fecha"
                      />
                    </div>
                    <div class="date-input" v-if="fecha_final">
                      <input
                        id="valido_hasta"
                        ref="valido_hasta"
                        class="single-daterange form-control"
                        placeholder="Habilitado Hasta"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.tipo_calculo &&
                          current.errors.tipo_calculo.length > 0,
                      }"
                      >Tipo Calculo</label
                    >
                    <select
                      class="form-control"
                      v-model="current.tipo_calculo"
                      @change="refrescarPrecioVenta"
                    >
                      <option value="PORC">Porcentaje</option>
                      <option value="FIJO">Fijo</option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tipo_calculo"
                      class="form-text text-danger"
                      >{{ current.errors.tipo_calculo[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for>Costo</label>
                    <div class="input-group">
                      <input
                        v-model="current.costo"
                        class="form-control"
                        @change="refrescarPrecioVenta"
                        placeholder="Costo"
                        type="number"
                        readonly="true"
                        min="0.05"
                        step="0.05"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for>Costo Unidad Medida</label>
                    <div class="input-group">
                      <input
                        v-model="current.costo_um"
                        class="form-control"
                        placeholder="Costo Unidad Medida"
                        type="number"
                        readonly="true"
                        min="0.05"
                        step="0.05"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for>Otros Costo</label>
                    <div class="input-group">
                      <input
                        v-model="current.otros_costos"
                        class="form-control"
                        @change="refrescarPrecioVenta"
                        placeholder="Otros Costos"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-bind:class="{
                    'text-danger': current.errors && current.errors.margen,
                  }"
                  class="col-sm-3"
                >
                  <div class="form-group">
                    <label for>Margen</label>
                    <div class="input-group">
                      <input
                        v-model="current.margen"
                        @change="refrescarPrecioVenta"
                        class="form-control"
                        placeholder="Margen"
                        type="text"
                      />
                      <div
                        class="input-group-prepend"
                        v-if="current.tipo_calculo == 'PORC'"
                      >
                        <div class="input-group-text">%</div>
                      </div>
                    </div>
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.margen"
                      >{{ current.errors.margen[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-12 modal-header faded">
                  <div class="col-12">
                    <a
                      class="element-box el-tablo centered trend-in-corner smaller"
                      href="#"
                    >
                      <div class="label">Precio de Venta</div>
                      <div class="value">Q {{ precio_venta }}</div>
                      <div
                        class="trending trending-up"
                        style="color: white !important"
                        v-if="porcentaFrenteUltimoPrecio >= 0"
                      >
                        <span style="color: white !important"
                          >{{ porcentaFrenteUltimoPrecio }}%</span
                        >
                        <i class="os-icon os-icon-arrow-up6"></i>
                      </div>
                      <div
                        class="trending trending-down"
                        style="color: white !important"
                        v-if="porcentaFrenteUltimoPrecio < 0"
                      >
                        <span style="color: white !important"
                          >{{ porcentaFrenteUltimoPrecio }}%</span
                        >
                        <i class="os-icon os-icon-arrow-down6"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="agregarPrecio"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import ProductosService from "@/services/catalogos/ProductosService";
import Notifications from "@/notifications/notifications";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ProductoUnidadMedidaSelectComponent,
  },
  data() {
    return {
      precio_actual: {},
      ultimo_precio: 0,
      precio_venta: 0,
      fecha_inicial: false,
      fecha_final: false,
      porcentaFrenteUltimoPrecio: 0,
      valido_hasta: null,
      current: {
        id: 0,
        nombre: "",
        producto: null,
        unidad_medida: null,
        valido_desde: null,
        valido_hasta: null,
        costo: 0,
        costo_um: 0,
        precio: 0,
        margen: 0,
        tipo_calculo: "PORC",
        errors: {
          nombre: [],
        },
      },
    };
  },
  props: {
    lista_precio: {
      type: Object,
      required: true,
      default: {},
    },
    producto: {
      type: Object,
      required: true,
      default: {
        productounidadmedida_set: [],
      },
    },
  },
  watch: {},
  computed: {
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
    ...mapGetters({
      unidades_medidas: "catalogos/unidades_medidas",
    }),
  },
  mounted() {
    let self = this;
    Vue.nextTick(function () {
      $("#valido_desde").daterangepicker({
        singleDatePicker: true,
        locale: {
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: "Aplicar",
          cancelLabel: "Cancelar",
          daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
          monthNames: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Deciembre",
          ],
          firstDay: 1,
        },
      });
    });
    CommonService.fecha_actual().then((res) => {
      self.current.valido_desde = res.data.fecha_actual;
      self.current.producto = self.producto;
    });
  },
  methods: {
    habilitarFechaFinal() {
      let self = this;
      self.fecha_final = true;
      Vue.nextTick(function () {
        $("#valido_hasta").daterangepicker({
          singleDatePicker: true,
          locale: {
            format: "DD/MM/YYYY",
            separator: " - ",
            applyLabel: "Aplicar",
            cancelLabel: "Cancelar",
            daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            monthNames: [
              "Enero",
              "Febrero",
              "Marzo",
              "Abril",
              "Mayo",
              "Junio",
              "Julio",
              "Agosto",
              "Septiembre",
              "Octubre",
              "Noviembre",
              "Deciembre",
            ],
            firstDay: 1,
          },
        });
      });
    },
    habilitarFechaInicial() {
      let self = this;
      self.fecha_inicial = true;
    },
    unidadMedidaChange() {
      this.refrescarCosto();
    },
    refrescarPrecioVenta() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "productos",
        self.producto.sku,
        "proyeccion_precio_individual",
        {
          unidad_medida: self.current.unidad_medida,
          margen: self.current.margen,
          costo: self.current.costo,
          otros_costos: self.current.otros_costos,
          tipo_calculo: self.current.tipo_calculo,
          lista_precio: self.lista_precio.id,
        }
      )
        .then((res) => {
          self.precio_venta = res.data.precio;
          self.current.costo_um = res.data.costo_um;
        })
        .catch((err) => {
          self.current.errors = err;
          self.precio_venta = 0;
          self.current.costo_um = 0;
        });
      /*
      let _precio = 0;
      let _margen = 0;
      let _costo = 0;
      if (self.current.margen) {
        _margen = parseFloat(self.current.margen);
      }
      if (self.current.costo) {
        self.current.costo = parseFloat(self.current.costo).toFixed(2);
        _costo = parseFloat(self.current.costo);
      }
      if (self.current.otros_costos) {
        self.current.otros_costos = parseFloat(
          self.current.otros_costos
        ).toFixed(2);
        _costo += parseFloat(self.current.otros_costos);
      }
      if (self.current.tipo_calculo == "PORC") {
        _precio = _costo + _costo * (_margen / 100);
      } else {
        _precio = _costo + _margen;
      }
      self.current.margen = parseFloat(self.current.margen).toFixed(2);

      _precio = parseFloat(_precio).toFixed(2);
      self.precio_venta = (Math.ceil(_precio * 20 - 0.5) / 20).toFixed(2);
      self.valido_hasta = _precio.valido_hasta;
      self.calcuarPorcentaFrenteUltimoPrecio();
      */
    },
    calcuarPorcentaFrenteUltimoPrecio() {
      let self = this;

      let _precio_venta = 0;
      if (self.precio_venta) {
        _precio_venta = parseFloat(self.precio_venta);
      }

      let _ultimo_precio = 0;
      if (self.precio_actual.precio_actual) {
        _ultimo_precio = parseFloat(self.precio_actual.precio_actual);
      }
      let diferencia = 0;
      if (_ultimo_precio == 0) {
        diferencia = 100;
      } else {
        diferencia = (_precio_venta * 100) / _ultimo_precio;
        diferencia = diferencia - 100;
      }
      self.porcentaFrenteUltimoPrecio = parseFloat(diferencia).toFixed(2);
    },
    refrescarCosto() {
      let self = this;

      DynamicService.fetch("cat", "producto-costo", {
        producto: self.current.producto.sku,
        quitar_paginacion: true,
      }).then((res) => {
        if (res.data.length == 0) {
          self.current.costo = 0;
        } else {
          self.current.costo = parseFloat(res.data[0].costo);
        }
        self.refrescarPrecioVenta();
      });
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    reset() {
      self.precio_actual = {};
      self.ultimo_precio = 0;
      self.precio_venta = 0;
      self.porcentaFrenteUltimoPrecio = 0;
      self.valido_hasta = null;
      self.current = {
        id: 0,
        nombre: "",
        producto: null,
        unidad_medida: null,
        valido_desde: null,
        valido_hasta: null,
        costo: 0,
        otros_costos: 0,
        precio: 0,
        margen: 0,
        tipo_calculo: "PORC",
        errors: {
          nombre: [],
        },
      };
    },
    agregarPrecio() {
      let self = this;

      var _current = Object.assign({}, this.current);
      _current.producto = self.current.producto.sku;
      _current.lista_precio = self.lista_precio.id;

      _current.valido_desde = null;
      if (self.$refs.valido_desde) {
        _current.valido_desde = self.$refs.valido_desde.value;
      }

      _current.valido_hasta = null;
      if (self.$refs.valido_hasta) {
        _current.valido_hasta = self.$refs.valido_hasta.value;
      }

      _current.estatus = true;
      delete _current.errors;
      delete _current.id;

      _current.precio = self.precio_venta;
      ProductosService.agregar_precio(_current)
        .then((res) => {
          self.current.errors = {};
          Notifications.alert.success(
            "Cambio de Precio Éxitoso",
            "Se ha agregado nuevo precio"
          );
          self.$refs.cerrarModal.click();
          self.reset();
          self.cerrandoModal();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
  },
};
</script>
